// extracted by mini-css-extract-plugin
export default {"table":"Table_table__TVUpg","thead":"Table_thead__v2ei5","reversed":"Table_reversed__LOgKP","tbody":"Table_tbody__MrTSi"};